/* GENERATED by scripts/gen-data.mjs — film scene "f-foundations" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_FOUNDATIONS: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "box",
      "id": "in",
      "x": 24,
      "y": 112,
      "w": 156,
      "h": 64,
      "lKey": "films:f-foundations.items.in.l",
      "sKey": "films:f-foundations.items.in.s"
    },
    {
      "k": "box",
      "id": "mdl",
      "x": 236,
      "y": 112,
      "w": 150,
      "h": 64,
      "lKey": "films:f-foundations.items.mdl.l",
      "sKey": "films:f-foundations.items.mdl.s"
    },
    {
      "k": "box",
      "id": "out",
      "x": 438,
      "y": 112,
      "w": 154,
      "h": 64,
      "lKey": "films:f-foundations.items.out.l",
      "sKey": "films:f-foundations.items.out.s"
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "in",
      "to": "mdl"
    },
    {
      "k": "wire",
      "id": "w2",
      "from": "mdl",
      "to": "out"
    },
    {
      "k": "bar",
      "id": "b1",
      "x": 438,
      "y": 196,
      "w": 154,
      "h": 8,
      "v": 0.92,
      "lKey": "films:f-foundations.items.b1.l"
    },
    {
      "k": "bar",
      "id": "b2",
      "x": 438,
      "y": 216,
      "w": 154,
      "h": 8,
      "v": 0.05,
      "lKey": "films:f-foundations.items.b2.l"
    },
    {
      "k": "bar",
      "id": "b3",
      "x": 438,
      "y": 236,
      "w": 154,
      "h": 8,
      "v": 0.03,
      "lKey": "films:f-foundations.items.b3.l"
    },
    {
      "k": "note",
      "id": "n1",
      "x": 24,
      "y": 206,
      "lKey": "films:f-foundations.items.n1.l"
    }
  ],
  "steps": [
    {
      "on": [
        "in"
      ],
      "hot": [
        "in"
      ],
      "capKey": "films:f-foundations.steps.0.cap"
    },
    {
      "on": [
        "in",
        "mdl",
        "w1"
      ],
      "hot": [
        "mdl",
        "w1"
      ],
      "capKey": "films:f-foundations.steps.1.cap"
    },
    {
      "on": [
        "in",
        "mdl",
        "out",
        "w1",
        "w2"
      ],
      "hot": [
        "out",
        "w2"
      ],
      "capKey": "films:f-foundations.steps.2.cap"
    },
    {
      "on": [
        "in",
        "mdl",
        "out",
        "w1",
        "w2",
        "b1",
        "b2",
        "b3"
      ],
      "hot": [
        "b1"
      ],
      "capKey": "films:f-foundations.steps.3.cap"
    }
  ]
};
